<template>
    <div>
        <div class="row file-header">
            
        	<div class="col-md-10 col-xs-12 col-sm-8 search-box">
	            <div class="search-box-row" v-bind:class="{active:isSearch}">
	                <b-form class="search-form" inline>
	                    <b-form-group
	                    id="input-group-1"
	                     class="search-field-group">
	                        <b-form-input
	                        id="input-1"
	                        v-model="form.search"
	                        type="text"
	                        required
	                        placeholder="Search..."
	                        ></b-form-input>
	                    </b-form-group>
                        <a href="javascript://" @click="SearchFiles()" class="btn btn-primary" v-if="searchbtn">Search</a> <span  v-if="reset"> <a href="javascript://" @click="resetSearch()" class="btn btn-primary-inverse">Reset</a></span>
	                </b-form>
	            </div>
        	</div>
	        <div class="col-md-2 col-xs-12 col-sm-4 button-group">
	          	<ul>
		            <li>
		              	<a href="javascript://" class="icon-search" @click="openSearch()" v-b-tooltip.hover title="Search">
		                	<svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" data-name="Layer 1" viewBox="0 0 29 29"><rect class="cls-3" x="0.13" y="0.13" width="28.74" height="28.74" rx="14.37"/><circle class="cls-4" cx="13.91" cy="13.63" r="4.22"/><line class="cls-4" x1="19.78" y1="21.05" x2="16.53" y2="16.94"/></svg>
		              	</a>
		            </li>
		            <li>
		              	<a href="javascript://" class="icon-file-upload" @click="$bvModal.show('mobal-fileupload')" v-b-tooltip.hover title="Upload">
		                	<svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" data-name="Layer 1" viewBox="0 0 29 29"><rect class="cls-3" x="0.13" y="0.13" width="28.74" height="28.74" rx="14.37"/><polyline class="cls-4" points="10.04 13.47 14.5 9.01 18.96 13.47"/><line class="cls-4" x1="14.5" y1="19.99" x2="14.5" y2="9.01"/></svg>
		              	</a>
		            </li>
	          	</ul>
	        </div>
        </div>
        <div class="row file-header" v-if="bread_crums.length > 1">
          <div class="col-md-12 col-xs-12 col-sm-12 bread_crums">
                <nav aria-label="breadcrumb" v-if="bread_crums.length > 1">
                    <ol class="breadcrumb">
                        <li v-for="list in bread_crums" :key="list.id">
                        <a href="javascript://" @click="GetInToFolder(list.id)">  {{list.name}}  </a>&nbsp; > &nbsp;
                      </li>
                    </ol>
                </nav>
            </div>
        </div>
       <!-- <div class="bread_crums" v-if="bread_crums.length > 1">
           <ul >
               <li v-for="list in bread_crums" :key="list.id">
                 <a href="javascript://" @click="GetInToFolder(list.id)">  {{list.name}}  </a>&nbsp; > &nbsp;
               </li>
           </ul>
       </div> -->
       <table class="table tbl-file-download">
           <!-- <thead>
               <tr>
                  <td>
                       <img src="../assets/icon-pin.png" >&nbsp;&nbsp;Pin
                   </td>
                   <td>
                       <img src="../assets/icon-name.png">&nbsp;&nbsp;File Name
                   </td>
                   <td>
                       <img src="../assets/icon-date.png">&nbsp;&nbsp;Date
                   </td>
                   <td>
                       <img src="../assets/icon-download.png">&nbsp;&nbsp;Download
                   </td>
                   <td width="2%" class="search-row">
                     <img src="../assets/icon-search.png" @click="openSearch()" v-b-tooltip.hover title="Search">
                   </td>
                   <td width="2%" class="upload-row">
                     <img src="../assets/icon-upload.png" @click="$bvModal.show('mobal-fileupload')" v-b-tooltip.hover title="Upload">
                   </td>
                   
               </tr>
           </thead> -->
            <tbody >
               <!--  <tr class="search-box-row" v-bind:class="{active:isSearch}">
                  <td colspan="6">
                    <b-form class="search-form">
                        <b-form-group
                        id="input-group-1"
                        >
                            <b-form-input
                            id="input-1"
                            v-model="form.search"
                            type="text"
                            required
                            placeholder="Search..."
                            ></b-form-input>
                        </b-form-group>
                    </b-form>
                  </td>
                </tr> -->
                <tr  v-for="folder in folders" :key="folder.id"   >
                    <td colspan="7" v-if="form.search==''"> 
                        <a href="javascript://" @click="GetInToFolder(folder.id)" class="folder"><img src="../assets/folder-icon.svg" >
                            {{folder.name}}</a>
                    </td>
                </tr>
                <tr   v-for="file in files" :key="file.id"> 
                   <!--  <td>
                        <img v-if="file.pinned" src="../assets/icon-pin-block.png" @click="pin(file.id,file.pinned)" style="cursor:pointer">
                        <img v-else src="../assets/icon-pin.png" @click="pin(file.id,file.pinned)" style="cursor:pointer">
                    </td> -->
                    <td>
                            {{file.label ? file.label :file.original_name}}
                    </td>
                    <td>
                        {{ formatDate(file.created_at, 'D-MMM-YYYY ') }}
                    </td>
                    <td>
                         <a target="_blank" :href="path+'business_setup/'+file.name">Download</a>&nbsp;&nbsp;|&nbsp;&nbsp;<img v-if="file.pinned" src="../assets/icon-pin-block.png" @click="pin(file.id,file.pinned)" style="cursor:pointer"><img v-else src="../assets/icon-pin.png" @click="pin(file.id,file.pinned)" style="cursor:pointer">
                    </td>
                    <td></td>
                    <td></td>
                   
                </tr>
                <tr v-if="files_present_search">
                        <td colspan="6" align="center">
                                No files found
                        </td>
                </tr>
            </tbody>
        </table>
        <div>
            <b-modal id="mobal-fileupload" centered title="Upload File" class="fileupload-modal">
                 <upload :UploadProps="{subscription_type:PropData.type,subscription_id:PropData.id,folder_id:folder_id}" @Newlist="GetFileList()" @closeModal="modalClose()"/>
            </b-modal>
        </div>
    </div>
</template>
<script>
import fileupload from '../services/fileupload'
import upload from "./file_upload.vue"
import moment from 'moment'
export default {
    name:'files',
    data(){
        return{
            PropData:{},
            files:{},
            reset:false,
            bread_crums:{},
            folders:{},
            files_present:false,
            files_present_search:false,
            path:process.env.VUE_APP_FILE_PATH,
            form: {
                search: '',   
            },
            isSearch:false,
            searchbtn:true,
            folder_id:''
        }
    },
      props:['subscription'],
    watch:{
        subscription: function (data){
            this.PropData=data
            this.folder_id=data.folder.id;
             this.GetFileList()
        }
    },
    components: {
        upload
    },
    methods: {
        GetFileList(){
            this.fetchFiles(this.folder_id);
            this.$bvModal.hide('mobal-fileupload');
        },
        returnImage(pinned){
             return pinned==1 ?'../assets/icon-pin-block.png':'../assets/icon-pin.png'
        },
        formatDate(date,format){
             return moment(date).format(format);
        },
        resetSearch(){
          this.searchbtn=true;
          this.reset=false;
            window.location.reload();
        },
        pin(id,status){
            fileupload.pin({id:id,status:status})
                    .then(response=>{
                        if(response.status==200){
                             this.$notify({
                                group: 'auth',
                                title:'Success',
                                type: 'success',
                                text: response.data.msg
                            });
                        this.GetFileList();
                        }
                    })
        },
        GetInToFolder(folder_id){
            this.folder_id=folder_id;
            this.fetchFiles(folder_id);
        },
        fetchFiles(folder_id){
            this.reset=false;
            fileupload.getFiles({folder_id:folder_id})
            .then(response=>{
               this.files=response.data.data;
               this.folders=response.data.folders;
               this.bread_crums=response.data.bread_crums;
               if(this.files.length>0){
                   this.files_present=true
               }
               
            })
        },
        modalClose(){
            
        },
        openSearch(){
            this.isSearch= this.isSearch== false ? true :false;
        },
        SearchFiles(){
            this.reset=true;
            this.searchbtn=false;
            fileupload.search({q:this.form.search,subsctiption_id:this.PropData.id})
            .then(response=>{
                this.files=response.data.data;
               if(this.files.length == 0){
                   this.files_present_search=true
               }else{
                   this.files_present_search=false
               }
            })
        }
    },
};
</script>